export const strings = {
  appName: 'أريب',
  // The motto, set under the wordmark wherever the lockup appears.
  tagline: 'منصة الجدارات',
  // The longer positioning line, for prose contexts rather than the lockup.
  description: 'كفاءات نوعية للقطاع غير الربحي',

  signInTitle: 'الدخول إلى أريب',
  signInPhoneLabel: 'رقم الجوال',
  signInPhonePlaceholder: '05xxxxxxxx',
  signInSendCode: 'إرسال رمز التحقق',
  signInCodeLabel: 'رمز التحقق',
  signInVerify: 'تأكيد',
  signInChangeNumber: 'تغيير الرقم',
  signInCodeSent: 'أرسلنا رمزاً إلى جوالك',

  errCooldown: 'انتظر دقيقة قبل طلب رمز جديد',
  errDailyLimit: 'تجاوزت عدد المحاولات لهذا اليوم',
  errTryLater: 'الخدمة مشغولة حالياً، حاول لاحقاً',
  errInvalidPhone: 'رقم الجوال غير صحيح',
  errWrongCode: 'الرمز غير صحيح',
  errTooManyAttempts: 'تجاوزت عدد المحاولات، اطلب رمزاً جديداً',
  errCodeExpired: 'انتهت صلاحية الرمز، اطلب رمزاً جديداً',
  errGeneric: 'تعذّر إتمام العملية، حاول مرة أخرى',

  unauthorizedTitle: 'لا تملك صلاحية الوصول لهذه الصفحة',
  signOut: 'تسجيل الخروج',

  roleAdmin: 'مدير النظام',
  roleRecruiter: 'أخصائي استقطاب',
  roleRecommender: 'مُرشِّح',
  roleNgoRep: 'ممثل جمعية',
  roleCandidate: 'كفاءة',
  roleGuest: 'زائر',

  userMenuOpen: 'قائمة المستخدم',
  viewSwitch: 'تبديل الواجهة',
  languageSwitch: 'اللغة',
  userNoName: 'بدون اسم',

  navStaffInvites: 'الدعوات',

  invitesTitle: 'الدعوات',
  inviteCreateTitle: 'دعوة عضو جديد',
  inviteName: 'الاسم',
  inviteRole: 'الدور',
  inviteSubmit: 'إنشاء الدعوة',
  invitePendingTitle: 'دعوات لم تُستخدم بعد',
  invitesEmpty: 'لا توجد دعوات معلّقة',
  inviteCreated: 'تم إنشاء الدعوة. يدخل صاحبها برقم جواله.',
  errAlreadyRegistered: 'هذا الرقم مسجّل بالفعل. غيّر دوره من صفحة المستخدمين.',
  errAdminOnlyRole: 'إنشاء حساب إداري يحتاج صلاحية مدير النظام',
  errInvalidRole: 'الدور غير صحيح',

  usersTitle: 'المستخدمون',
  userAddTitle: 'إضافة مستخدم',
  userAddHint: 'رقم الجوال والاسم فقط. يدخل الحساب بدور «زائر»، وتحدّد دوره من القائمة أدناه.',
  userAddSubmit: 'إضافة',
  userAdded: 'تم إنشاء الحساب. حدّد دوره الآن.',
  errNameRequiredUser: 'اكتب اسم المستخدم',
  errUserAlreadyRegistered: 'هذا الرقم مسجّل بالفعل. ستجده في القائمة أدناه.',
  usersEmpty: 'لا يوجد مستخدمون بعد',
  userChangeRole: 'تغيير الدور',
  userYou: 'أنت',
  userCannotChangeSelf: 'لا يمكنك تغيير دورك بنفسك',
  errCannotChangeOwnRole: 'لا يمكنك تغيير دورك بنفسك. اطلب ذلك من مدير آخر.',
  errUserNotFound: 'المستخدم غير موجود',

  taxonomyTitle: 'شجرة الكفاءات',
  taxonomyActivate: 'تفعيل',
  taxonomyDeactivate: 'إيقاف',
  taxonomyInactive: 'موقوف',
  taxonomyReseed: 'تحديث الشجرة من الملف',
  taxonomyReseeded: 'تم تحديث الشجرة',
  taxonomyEmpty: 'الشجرة فارغة. حدّثها من الملف.',
  errTagNotFound: 'هذه الكفاءة غير موجودة',
  errNothingToChange: 'لم يتغيّر شيء',

  reportSurvival30: 'استمرار 30 يوماً',
  reportTimeToVetted: 'وسيط المدة حتى الاعتماد',
  reportTimeToActivated: 'وسيط المدة حتى التفعيل',
  reportAssessments: 'تقييمات مكتملة',
  reportRecommendersTitle: 'المُرشِّحون',
  reportColRecommender: 'المُرشِّح',
  reportColSubmitted: 'ترشيحات',
  reportColVetted: 'معتمدة',
  reportColQuality: 'الجودة',
  reportNotEnoughYet: 'لا يكفي بعد',
  unitDays: 'يوم',

  navCollapse: 'تصغير القائمة',
  navExpand: 'توسيع القائمة',
  navOpen: 'فتح القائمة',
  navClose: 'إغلاق القائمة',

  navAdminOverview: 'لوحة التحكم',
  navAdminUsers: 'المستخدمون',
  navAdminTaxonomy: 'شجرة الكفاءات',
  navRecruiterQueue: 'قائمة الترشيحات',
  navRecruiterCandidates: 'الكفاءات',
  navRecruiterOpportunities: 'الفرص',
  navRecruiterMatches: 'المواءمة',
  navRecommenderNominate: 'ترشيح كفاءة',
  navRecommenderMine: 'ترشيحاتي',
  navOrgAssessment: 'تقييم الاحتياج',
  navOrgOpportunities: 'فرصنا',
  navOrgMatches: 'المرشحون',
  navCandidateProfile: 'ملفي',
  navCandidateDiagnostic: 'التشخيص الكتابي',
  navCandidateOpportunities: 'الفرص المقترحة',
  navGuestRegisterOrg: 'تسجيل جمعية',
  guestWelcome: 'حسابك جاهز. سجّل جمعيتك للبدء، أو انتظر دعوة من فريق أريب.',

  stageNominated: 'مُرشَّح',
  stageContacted: 'تم التواصل',
  stageInterviewed: 'تمت المقابلة',
  stageVetted: 'معتمد',
  stageMatched: 'مطابَق',
  stageActive: 'نشط',
  stageInactive: 'غير نشط',
  stageWithdrawn: 'انسحب',
  statusSubmitted: 'جديد',
  statusContacted: 'تم التواصل',
  statusInterested: 'مهتم',
  statusNotNow: 'ليس الآن',
  statusDeclined: 'اعتذر',
  statusPromoted: 'أصبح كفاءة',
  statusRejected: 'مستبعد',

  nominateTitle: 'ترشيح كفاءة',
  nominateIntro: 'يكفي اسم ورقم جوال وسطر واحد عن سبب تميّزه.',
  nominateName: 'اسم الكفاءة',
  nominateWhy: 'لماذا هذا الشخص استثنائي؟',
  nominateRole: 'المسمى الوظيفي (اختياري)',
  nominateEmployer: 'جهة العمل (اختياري)',
  nominateCity: 'المدينة (اختياري)',
  nominateSubmit: 'إرسال الترشيح',
  nominateSent: 'وصلنا ترشيحك، شكراً لك',
  nominateDuplicate: 'هذا الرقم مُرشَّح من قبل، وسجّلنا ترشيحك أيضاً',
  nominateAnother: 'ترشيح شخص آخر',
  myNominationsTitle: 'ترشيحاتي',
  myNominationsEmpty: 'لم ترشّح أحداً بعد',
  colName: 'الاسم',
  colStatus: 'الحالة',
  colDate: 'التاريخ',
  loading: 'جارٍ التحميل…',
  loadFailed: 'تعذّر تحميل البيانات',
  errNameRequired: 'اكتب اسم الكفاءة',
  errWhyRequired: 'اكتب سبب الترشيح',
  errWhyTooLong: 'السبب طويل جداً',
  errNotARecommender: 'حسابك لا يملك صلاحية الترشيح',

  queueTitle: 'قائمة الترشيحات',
  queueEmpty: 'لا توجد ترشيحات بانتظار المراجعة',
  queueOpenOnly: 'المفتوحة فقط',
  queueAll: 'الكل',
  colRecommender: 'المُرشِّح',
  colWhy: 'سبب الترشيح',
  colPhone: 'الجوال',
  outcomeContacted: 'تم التواصل',
  outcomeInterested: 'مهتم',
  outcomeNotNow: 'ليس الآن',
  outcomeDeclined: 'اعتذر',
  outcomeRejected: 'استبعاد',
  outcomePromote: 'ترقية إلى كفاءة',
  outcomeNote: 'ملاحظة (اختياري)',
  duplicateBadge: 'مُرشَّح مرتين',
  errAlreadyResolved: 'هذا الترشيح مغلق',
  errNotInterested: 'لا يمكن الترقية قبل تسجيل اهتمام الكفاءة',
  errAlreadyCandidate: 'هذا الرقم موجود في قاعدة الكفاءات',
  candidatesTitle: 'الكفاءات',
  candidatesEmpty: 'لا توجد كفاءات بعد',
  candidateInterviewTitle: 'بيانات المقابلة',
  candidateSave: 'حفظ',
  candidateSaved: 'تم الحفظ',
  candidateVet: 'اعتماد في القاعدة',
  candidateVetted: 'تم الاعتماد',
  candidateNotesTitle: 'ملاحظات',
  candidateAddNote: 'إضافة ملاحظة',
  candidateNoteKind: 'النوع',
  noteKindScreening: 'مقابلة',
  noteKindReference: 'تزكية',
  noteKindFollowup: 'متابعة',
  fieldYears: 'سنوات الخبرة',
  fieldSector: 'القطاع',
  fieldBio: 'نبذة',
  fieldHours: 'ساعات أسبوعياً',
  fieldFlexibility: 'المرونة',
  fieldMode: 'نمط العمل',
  fieldCauses: 'مجالات الاهتمام',
  competenciesTitle: 'الكفاءات والمهارات',
  competencyAdd: 'إضافة مهارة',
  competencyLevel: 'المستوى',
  competencyRemove: 'حذف',
  consentPending: 'بانتظار موافقة الكفاءة',
  consentGranted: 'وافق على المشاركة',
  consentWithdrawn: 'سحب الموافقة',
  sectorPrivate: 'القطاع الخاص',
  sectorGovernment: 'القطاع الحكومي',
  sectorAcademic: 'أكاديمي',
  sectorOther: 'أخرى',
  modeOnsite: 'حضوري',
  modeRemote: 'عن بُعد',
  modeHybrid: 'هجين',
  modeField: 'ميداني',

  zoneNorth: 'شمال الرياض',
  zoneEast: 'شرق الرياض',
  zoneWest: 'غرب الرياض',
  zoneSouth: 'جنوب الرياض',
  zoneCentral: 'وسط الرياض',
  zoneOutside: 'خارج الرياض',

  studyEarlyYears: 'طالب في السنوات الأولى إلى الثالثة',
  studyFinalYear: 'طالب في السنة الأخيرة',
  studyGraduatedWithinTwo: 'متخرج خلال السنتين الماضيتين',
  studyGraduatedOverTwo: 'متخرج منذ أكثر من سنتين',

  employmentStudyingOnly: 'أدرس ولا أعمل',
  employmentStudyingPartTime: 'أدرس وأعمل بدوام جزئي',
  employmentNotWorking: 'غير مرتبط بعمل حالياً',
  employmentPartTime: 'موظف بدوام جزئي',
  employmentFullTime: 'موظف بدوام كامل',

  fieldStatusActive: 'على رأس العمل حالياً',
  fieldStatusAwayUnderYear: 'منقطع أقل من سنة',
  fieldStatusAwayOverYear: 'منقطع أكثر من سنة',

  timeMorning: 'صباحاً',
  timeEvening: 'مساءً',
  timeByAgreement: 'حسب الاتفاق',

  durationThreeMonths: '3 أشهر',
  durationSixMonths: '6 أشهر',
  durationOneYear: 'سنة',
  durationOngoing: 'مستمرة',
  durationProjectBound: 'مرتبطة بمشروع',

  priorityUrgent: 'عاجلة',
  priorityWithinMonth: 'خلال شهر',
  priorityWithinQuarter: 'خلال شهرين إلى ثلاثة',
  priorityFlexible: 'مرنة',

  fundingOrg: 'الجهة',
  fundingDonor: 'جهة مانحة',
  fundingOther: 'أخرى',
  fundingNotApplicable: 'غير منطبق',

  cadenceWeeklyMeeting: 'اجتماع أسبوعي',
  cadenceMonthlyReport: 'تقرير شهري',
  cadenceDeliverables: 'تسليم مخرجات',
  cadenceOther: 'أخرى',

  workStyleBoth: 'كلاهما',

  fieldZone: 'النطاق',
  fieldDistrict: 'الحي',
  fieldTravelZones: 'نطاقات تستطيع التنقل إليها',
  fieldEmail: 'البريد الإلكتروني',
  fieldAge: 'العمر',
  fieldStudyStatus: 'حالتك الدراسية',
  fieldMajor: 'التخصص الأكاديمي',
  fieldGraduationYear: 'سنة التخرج الفعلية أو المتوقعة',
  fieldEmploymentStatus: 'حالتك الوظيفية الحالية',
  fieldFieldStatus: 'حالتك الحالية في الميدان القيمي',
  fieldEnvironment: 'البيئة القيمية التي تشرف فيها',
  fieldSupervisionYears: 'عدد سنوات الإشراف',
  fieldWorkStyle: 'بيئة العمل التي تفضّلها',
  fieldModes: 'نمط التنفيذ المفضل',
  fieldCvUrl: 'رابط سيرتك الذاتية',
  fieldSkillsOther: 'مهارات أخرى',

  oppPurpose: 'الهدف من الفرصة',
  oppOutcomes: 'المخرجات المتوقعة',
  oppRoleType: 'نوع الدور',
  oppExperienceWanted: 'الخبرات المطلوبة',
  oppMinYears: 'الحد الأدنى للخبرة',
  oppMinYearsNone: 'غير محدد',
  unitYears: 'سنة',
  oppTimes: 'الأوقات المفضلة',
  oppFlexibility: 'مرونة الوقت',
  oppDurationKind: 'مدة الفرصة',
  oppFundingSource: 'مصدر تغطية المقابل',
  oppHeadcount: 'عدد الأشخاص المطلوبين',
  oppPriority: 'أولوية شغل الفرصة',
  oppNotes: 'ملاحظات إضافية',
  oppStartWhenMatched: 'فور اكتمال الترشيح',
  oppReviewCadence: 'آلية المتابعة',

  diagnosticTitle: 'أسئلة التشخيص الكتابية',
  diagnosticIntro: 'هذه مقابلة مكتوبة لا استبانة سريعة. أسئلتها مفتوحة عن قصد، وإجابتك المفصّلة هي ما يمكّن فريق التشخيص من قراءة تجربتك على حقيقتها. تستغرق من 15 إلى 20 دقيقة، ويُفضّل إكمالها في جلسة واحدة.',
  diagnosticCareer: 'قدّم نبذة مختصرة عن مسيرتك المهنية، مع الإشارة إلى أبرز مسؤولياتك التي كنت تقوم بها فعلياً',
  diagnosticFormative: 'ما أبرز ثلاث مسؤوليات ترى أنها أسهمت في بناء خبراتك؟',
  diagnosticOutside: 'ما المسؤوليات أو الأعمال التي توليتها خارج نطاق الإشراف القيمي؟ اذكرها بإيجاز، وما الذي أضافته إلى خبرتك',
  diagnosticAchievements: 'ما أبرز ثلاثة إنجازات تعتز بها خلال مسيرتك العملية؟',
  diagnosticLeadership: 'أيٌّ من الأوصاف التالية يمثل أسلوبك السائد في قيادة فريقك لاتخاذ القرارات وإدارة العمل؟',
  diagnosticLeadershipHint: 'اختر وصفين على الأكثر.',
  diagnosticTeamRole: 'عند العمل ضمن فريق، ما الدور الذي تجد نفسك تؤديه غالباً بشكل تلقائي؟ ولماذا؟',
  diagnosticMotivations: 'ما الذي يجذبك إلى المجالات والأدوار التي اخترتها في استمارة الترشيح؟ وما الدور الذي تتطلع إلى بلوغه في العمل الخيري خلال السنوات القادمة؟',
  diagnosticDriver: 'ما الذي يدفعك في هذه المرحلة إلى الرغبة في الإسهام في القطاع غير الربحي؟',
  diagnosticAnythingElse: 'هل هناك خبرة، أو فكرة، أو جانب من شخصيتك المهنية ترى أنه لم تتناوله الأسئلة السابقة، وتودّ أن يعرفه فريق التشخيص؟',
  diagnosticSubmit: 'إرسال التشخيص',
  diagnosticSaved: 'وصلت إجاباتك إلى فريق التشخيص',
  diagnosticDone: 'أكملت التشخيص الكتابي. سنتواصل معك للمقابلة إن كنت من الأنسب للفرص المتاحة.',
  leadStyleDecisive: 'السرعة في اتخاذ القرارات، والحسم بين الخيارات، والتركيز العالي على تحقيق النتائج',
  leadStyleInspiring: 'تحفيز الفريق، وبناء العلاقات، والإقناع، وصناعة البيئة المشجعة للابتكار',
  leadStyleCollaborative: 'تعزيز التعاون، وبناء الانسجام، والاهتمام بتطوير أفراد الفريق',
  leadStyleMethodical: 'التركيز على التخطيط، وتحليل التفاصيل، وضبط الجودة، والالتزام بالمعايير',
  errTooManyStyles: 'اختر وصفين على الأكثر',
  errDiagnosticIncomplete: 'أكمل جميع الأسئلة المطلوبة',
  stageDiagnosed: 'أكمل التشخيص',
  flexFixed: 'ثابت',
  flexFlexible: 'مرن',
  flexByTasks: 'حسب طبيعة المهام',
  errConsentRequired: 'لا يمكن الاعتماد قبل موافقة الكفاءة',
  errCompetenciesRequired: 'أضف مهارة واحدة على الأقل قبل الاعتماد',
  errInvalidStage: 'لا يمكن تنفيذ هذا الإجراء في هذه المرحلة',
  consentTitle: 'الانضمام إلى قاعدة كفاءات أريب',
  consentBody: 'رشّحك أحدهم للانضمام إلى قاعدة الكفاءات. بموافقتك، يطّلع فريق أريب على ملفك، ولا تُعرض بياناتك على أي جهة قبل موافقتك على فرصة بعينها. يمكنك سحب موافقتك في أي وقت.',
  consentAgree: 'أوافق',
  consentWithdraw: 'سحب الموافقة',
  consentWithdrawn2: 'تم سحب موافقتك. لن تُعرض بياناتك على أي جهة.',
  myProfileTitle: 'ملفي',
  profileSaved: 'تم حفظ ملفك',

  registerOrgTitle: 'تسجيل جمعية',
  registerOrgIntro: 'سجّل جمعيتك للبدء. يمكنك إكمال تشخيص الاحتياج وإعداد الفرص فوراً، والاعتماد مطلوب قبل النشر فقط.',
  orgName: 'اسم الجمعية',
  orgCity: 'المدينة',
  orgMission: 'رسالة الجمعية',
  orgSize: 'عدد العاملين',
  orgFounded: 'سنة التأسيس',
  orgCauses: 'مجالات العمل',
  orgContactName: 'اسم مسؤول التواصل',
  orgContactTitle: 'المسمى الوظيفي',
  orgCrNumber: 'رقم السجل (اختياري)',
  orgLicense: 'رقم الترخيص (اختياري)',
  registerOrgSubmit: 'تسجيل الجمعية',
  registerOrgDone: 'تم تسجيل جمعيتك. يمكنك البدء الآن.',
  errAlreadyHasRole: 'حسابك مرتبط بجهة بالفعل',
  errOrgAlreadyRegistered: 'سجّلت جمعية من قبل',
  errCityRequired: 'اكتب المدينة',
  errMissionRequired: 'اكتب رسالة الجمعية',
  errInvalidSize: 'اختر عدد العاملين',
  assessmentTitle: 'تقييم احتياج الجهة',
  assessmentIntro: 'ثلاث خطوات: أين أنتم الآن، ما الذي تغطونه فعلاً، وأي فجوة تعيق الخطوة القادمة.',
  assessmentSaved2: 'تم حفظ التقييم',
  assessmentStage: 'أين أنتم الآن',
  assessmentStaff: 'عدد العاملين',
  assessmentVolunteers: 'عدد المتطوعين',
  assessmentBudget: 'النطاق المالي السنوي',
  assessmentAmbition: 'ماذا تعني الخطوة القادمة خلال 12–18 شهراً؟',
  assessmentCoverage: 'التغطية الحالية',
  assessmentPriorities: 'أهم الفجوات',
  assessmentSave: 'حفظ التشخيص',
  assessmentSaved: 'تم حفظ التشخيص',
  coverageHaveCraft: 'لدينا من يتقنها',
  coverageTasksOnly: 'المهام تُنجز، لكن الخبرة غير متوفرة',
  coverageNothing: 'لا يوجد',
  coverageNotNeeded: 'غير مطلوبة',
  coverageHint: 'الفرق بين «يتقنها» و«المهام تُنجز» هو جوهر التشخيص.',
  errPrioritiesRequired: 'اختر فجوة واحدة على الأقل',
  errTooManyPriorities: 'ثلاث فجوات كحد أقصى',
  errIncompleteCoverage: 'أجب عن كل المجالات',
  errNotAGap: 'لا يمكن اختيار مجال قلت إن لديكم من يتقنه',
  oppsTitle: 'فرصنا',
  oppsEmpty: 'لا توجد فرص بعد',
  oppNew: 'فرصة جديدة',
  oppNewTitle: 'المسمى (دور واحد فقط)',
  oppCreate: 'إنشاء مسودة',
  oppFromGap: 'من فجوة',
  oppSummary: 'وصف مختصر',
  oppTasks: 'المهام والمخرجات',
  oppTask: 'المهمة',
  oppDeliverable: 'المخرَج',
  oppAddTask: 'إضافة مهمة',
  oppRemoveTask: 'حذف المهمة',
  oppWorkStyle: 'طبيعة العمل',
  oppStyleIndividual: 'فردي',
  oppStyleTeam: 'ضمن فريق',
  oppLocation: 'الموقع',
  oppRequired: 'المهارات المطلوبة',
  oppPreferred: 'المهارات المفضلة',
  oppRequirementsHint: 'اقتصر على ما لا تقوم الفرصة بدونه. كل شرط إضافي يقلّص المرشحين دون أن يحسّنهم.',
  oppDuration: 'المدة بالأشهر',
  oppCompensation: 'طبيعة العلاقة',
  compPaidPartTime: 'دوام جزئي براتب',
  compLumpSum: 'مبلغ مقطوع لكل مخرَج',
  compConsulting: 'عقد استشاري',
  compVolunteer: 'مساهمة تطوعية',
  oppAmount: 'المبلغ بالريال',
  oppReportsTo: 'يرتبط بـ',
  oppSuccess: 'معايير النجاح',
  oppSaveDraft: 'حفظ المسودة',
  oppSubmit: 'إرسال للمراجعة',
  oppSubmitted: 'أُرسلت للمراجعة',
  oppStatusDraft: 'مسودة',
  oppStatusSubmitted: 'قيد الإرسال',
  oppStatusUnderReview: 'قيد المراجعة',
  oppStatusLive: 'منشورة',
  oppStatusPaused: 'موقوفة',
  oppStatusFilled: 'مكتملة',
  oppStatusClosed: 'مغلقة',
  errOneRolePerCard: 'الفرصة الواحدة لدور واحد. افصل الأدوار في بطاقتين.',
  errTasksRange: 'من 3 إلى 6 مهام، ولكل مهمة مخرَج',
  errRequiredCompetencies: 'أضف مهارة مطلوبة واحدة على الأقل',
  errTooManyRequired: 'خمس مهارات مطلوبة كحد أقصى',
  errLocationRequired: 'اكتب الموقع للعمل الحضوري',
  errAmountRequired: 'حدد المبلغ',
  errDurationRequired: 'حدد المدة',
  errReportsToRequired: 'حدد الارتباط الإداري',
  errSuccessCriteria: 'أضف معيار نجاح واحداً على الأقل',
  errSummaryRequired: 'اكتب وصفاً مختصراً',
  errNotADraft: 'لا يمكن إرسال بطاقة غير مسودة',
  errNotPrioritizedGap: 'هذه الفجوة ليست ضمن أولوياتكم',
  errOrgNotApproved: 'لا يمكن النشر قبل اعتماد الجمعية',
  orgApprovalsTitle: 'اعتماد الجمعيات',
  orgApprovalsEmpty: 'لا توجد جمعيات بانتظار الاعتماد',
  orgApprove: 'اعتماد',
  orgReject: 'رفض',
  orgSuspend: 'إيقاف',
  orgDecisionReason: 'السبب (اختياري)',
  oppReviewTitle: 'مراجعة الفرص',
  oppReviewEmpty: 'لا توجد فرص بانتظار المراجعة',
  oppPublish: 'نشر',
  oppSendBack: 'إعادة كمسودة',
  oppPause: 'إيقاف مؤقت',
  oppReviewNote: 'ملاحظة للجهة',

  matchesTitle: 'المواءمة',
  matchPickOpportunity: 'اختر فرصة منشورة',
  matchRank: 'ترشيح المطابقين',
  matchNoOpportunities: 'لا توجد فرص منشورة بعد',
  matchNoCandidates: 'لا يوجد مطابقون لهذه الفرصة',
  matchPropose: 'اقتراح على الكفاءة',
  matchProposed: 'أُرسل للكفاءة',
  matchActivate: 'تفعيل المشاركة',
  matchActivated: 'بدأت المشاركة',
  matchOpenTitle: 'المواءمات الجارية',
  matchStatusProposed: 'بانتظار رد الكفاءة',
  matchStatusCandidateAccepted: 'وافقت الكفاءة، بانتظار الجهة',
  matchStatusCandidateDeclined: 'اعتذرت الكفاءة',
  matchStatusOrgAccepted: 'وافقت الجهة',
  matchStatusOrgDeclined: 'اعتذرت الجهة',
  matchStatusActive: 'مشاركة نشطة',
  matchStatusCompleted: 'مكتملة',
  matchStatusEndedEarly: 'انتهت مبكراً',
  myOpportunitiesTitle: 'الفرص المقترحة',
  myOpportunitiesEmpty: 'لا توجد فرص مقترحة لك حالياً',
  matchAccept: 'أوافق',
  matchDecline: 'أعتذر',
  matchAnswered: 'سجّلنا ردك',
  orgMatchesTitle: 'المرشحون',
  orgMatchesEmpty: 'لا يوجد مرشحون بانتظار مراجعتكم',
  orgMatchAccept: 'قبول المرشح',
  orgMatchDecline: 'اعتذار',
  matchWhyTitle: 'أسباب المطابقة',
  errAlreadyProposed: 'هذه الكفاءة مقترحة على هذه الفرصة بالفعل',
  errNotAMatch: 'لا تنطبق متطلبات الفرصة على هذه الكفاءة',
  errNotVetted: 'الكفاءة غير معتمدة بعد',
  errInvalidTransition: 'لا يمكن تنفيذ هذه الخطوة في هذه المرحلة',
  errNotYourMatch: 'هذه المواءمة ليست لك',
  errNotLive: 'الفرصة غير منشورة',
  reportsTitle: 'التقارير',
  reportNominations: 'الترشيحات',
  reportCandidates: 'الكفاءات',
  reportVetted: 'المعتمدون',
  reportOrgs: 'الجمعيات',
  reportOpportunitiesLive: 'الفرص المنشورة',
  reportMatchesActive: 'المشاركات النشطة',
  reportSurvival90: 'استمرار 90 يوماً',
  reportNoData: 'لا توجد بيانات بعد',
} as const;
